import { IError } from 'common-lib';

type ERRORS =
    | 'generic'
    | 'server-error'
    | 'wizard-invalid-new-contact'
    | 'wizard-no-name-new-contact'
    | 'wizard-unsaved-new-contact'
    | 'wizard-no-availability'
    | 'wizard-no-calendar-provider'
    | 'wizard-external-on-behalf-insufficient-invitees'
    | 'wizard-no-availability-past'
    | 'wizard-no-availability-range'
    | 'wizard-no-availability-specific-time'
    | 'wizard-no-availability-specific-time-default'
    | 'basic-user-restriction';

export const ERROR_MESSAGES: { [path in ERRORS]: IError } = {
    generic: {
        icon: 'meteor',
        category: 'generic',
        title: 'Oops!',
        content:
            'Something went wrong, but our team has been notified. Please email hello@calendarhero.com if you require assistance.',
        cta: null
    },
    'basic-user-restriction': {
        icon: 'user lock',
        title: `Sorry $VALUE,`,
        content: 'your Basic Plan only includes limited usage of this feature. To unlock this feature and others ',
        cta: `<a href="/settings/billing">upgrade your account now</a>.`
    },
    'server-error': {
        icon: 'meteor',
        category: 'generic',
        title: 'Hmmm.',
        content: '$VALUE',
        cta: null
    },
    'wizard-invalid-new-contact': {
        category: 'add-contact',
        content: 'Please make sure you use a valid email address.'
    },
    'wizard-no-name-new-contact': {
        category: 'add-contact',
        content: 'Please add a name for your new contact.'
    },
    'wizard-unsaved-new-contact': {
        category: 'add-contact',
        title: 'Wait!',
        content: 'Please remember to save or discard your changes before continuing.'
    },
    'wizard-no-availability': {
        category: 'availability',
        icon: 'calendar times',
        title: 'Scheduling Conflict:',
        content: `There is no availability $VALUE.`,
        cta: 'Select an alternate time frame.'
    },
    'wizard-no-calendar-provider': {
        icon: 'calendar times',
        content: `Looks like you don't have a calendar provider, or the one you've set is not working.`,
        cta: `Please check your <a href="/settings/accounts/list">Integrations</a>.`
    },
    'wizard-no-availability-past': {
        category: 'availability',
        title: '',
        content: 'There is no availability $VALUE. Selected time is in the past.',
        cta: 'Please select an alternate time.'
    },
    'wizard-no-availability-range': {
        category: 'availability',
        icon: 'calendar times',
        title: 'Scheduling Conflict:',
        content: `There is no availability $VALUE.`,
        cta: 'Please select an alternate time frame.'
    },
    'wizard-no-availability-specific-time': {
        category: 'availability',
        icon: 'calendar times',
        title: 'Scheduling Conflict:',
        content: `There is no availability $VALUE.`,
        cta: `Please select an alternate time OR click 'Next' below to ignore the conflicts and double book.`
    },
    'wizard-no-availability-specific-time-default': {
        category: 'availability',
        icon: 'calendar times',
        title: 'Scheduling Conflict:',
        content: `There is no availability $VALUE. This is due to an existing calendar event or availability setting.`,
        cta: `Please select an alternate time OR click 'Next' below to ignore the conflicts and double book.`
    },
    'wizard-external-on-behalf-insufficient-invitees': {
        content: 'Please add more than 1 invitee to this External On-Behalf meeting.'
    }
};
